import { __awaiter, __generator } from "tslib";
import { logPerformance } from '@office-start/telemetry-service';
import { getKeyFeatures } from './getKeyFeatures';
import { getPageTimings } from './getPageTimings';
import { getTTVRMarkerName } from './getTTVRMarkerName';
import { listenForInteractionOrHide } from './utils';
function getTTVRMarker(entry) {
    var name = entry.name, startTime = entry.startTime;
    if (name.startsWith('Paint_')) {
        var nameSplit = name.split('_');
        if (nameSplit.length >= 2) {
            var feature = nameSplit[1];
            var latency = Math.round(startTime);
            return {
                feature: feature,
                latency: latency,
            };
        }
    }
    else if (name === 'shell_plus_end') {
        return {
            feature: 'Shell',
            latency: Math.round(startTime),
        };
    }
    return undefined;
}
function logTTVR() {
    var ttvrLatency = getPageTimings()['TTVR'];
    if (ttvrLatency) {
        logPerformance({
            eventName: 'TTVR',
            latency: ttvrLatency,
        });
    }
}
function parseTTVRMarkers(performanceMarks, observer) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var pageTimings, keyFeatures, ttvrLatency, i, entry, ttvrMarker, feature, latency, eventName;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    pageTimings = getPageTimings();
                    return [4 /*yield*/, getKeyFeatures()];
                case 1:
                    keyFeatures = _b.sent();
                    if (!keyFeatures.size) {
                        observer === null || observer === void 0 ? void 0 : observer.disconnect();
                        return [2 /*return*/];
                    }
                    ttvrLatency = (_a = pageTimings['TTVR']) !== null && _a !== void 0 ? _a : 0;
                    for (i = 0; i < performanceMarks.length; i++) {
                        entry = performanceMarks[i];
                        ttvrMarker = getTTVRMarker(entry);
                        if (!ttvrMarker) {
                            continue;
                        }
                        feature = ttvrMarker.feature, latency = ttvrMarker.latency;
                        // If not a key feature for the page don't add TTVR
                        // TODO: Should we still log ttvr for non key metrics?
                        if (!keyFeatures.has(feature)) {
                            continue;
                        }
                        eventName = getTTVRMarkerName(feature);
                        if (!pageTimings[eventName]) {
                            logPerformance({
                                eventName: eventName,
                                latency: latency,
                            });
                            pageTimings[eventName] = latency;
                            ttvrLatency = Math.max(ttvrLatency, latency);
                        }
                    }
                    if (ttvrLatency > 0) {
                        pageTimings['TTVR'] = ttvrLatency;
                    }
                    return [2 /*return*/];
            }
        });
    });
}
function setupTTVRObserverInternal() {
    try {
        var observer_1 = new PerformanceObserver(function (list, observer) {
            var entries = list.getEntriesByType('mark');
            parseTTVRMarkers(entries, observer);
        });
        observer_1.observe({ type: 'mark', buffered: true });
        return function () {
            if (observer_1) {
                observer_1.disconnect();
                logTTVR();
            }
        };
    }
    catch (_a) {
        // Performance observer not supported
        return function () {
            try {
                // Try logging when we cleanup the observer later
                var entries = performance.getEntriesByType('mark');
                parseTTVRMarkers(entries);
                logTTVR();
            }
            catch (_a) {
                // Do nothing
            }
        };
    }
}
export function setupTTVRObserver(lcpDisabled) {
    if (lcpDisabled === void 0) { lcpDisabled = false; }
    var cleanup = setupTTVRObserverInternal();
    if (lcpDisabled) {
        // If we don't have the lcp event to
        // listen to setup a similiar handler to
        // log the overall TTVR
        listenForInteractionOrHide(cleanup);
        return;
    }
    return cleanup;
}
//# sourceMappingURL=setupTTVRObserver.js.map